import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-environment-change-dialog',
    templateUrl: './environment-change-dialog.component.html',
    styleUrls: ['./environment-change-dialog.component.scss']
})
export class EnvironmentChangeDialogComponent implements OnInit {

    title: string;
    message: string;
    buttons: any;
    buttonDefinitions: string[];
    @Input()
    public opened = false;
    @Output()
    public closed = new EventEmitter<object>();
    private _password: number;

    constructor() {
        this.opened = false;
    }

    ngOnInit(): void {
    }

    public open(type: string,
                title: string,
                message: string = '',
                cancel: string = 'Cancel',
                confirm: string = 'Ok',
                minWidth: number = 250,
                width: number = 450,
                minHeight: number = 250,
                height: number = 0): Promise<any> {
        this.title = title;
        this.message = '';
        this.buttonDefinitions = ['Cancel', 'Ok'];
        this.opened = true;
        return this.closed.asObservable()
            .pipe(take(1))
            .toPromise();
    }

    public close(event: any) {
        const x = { buttonText: event.target.innerHTML, input: this._password};
        this.opened = false;
        this.closed.emit(x);
        this._password = null;
    }
}
